import { render } from "./AiAssistantPage.vue?vue&type=template&id=47d8d0a5&scoped=true"
import script from "./AiAssistantPage.vue?vue&type=script&lang=js"
export * from "./AiAssistantPage.vue?vue&type=script&lang=js"

import "./AiAssistantPage.vue?vue&type=style&index=0&id=47d8d0a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d8d0a5"]])

export default __exports__